import React from "react";
import { NotificationBadge } from "./NotificationBadge";

interface StatusIconProps {
  icon: React.ReactNode;
  count?: number;
  variant?: "error" | "warning" | "info" | "neutral" | "refresh" | "override";
  className?: string;
  onClick?: () => void;
}

export const StatusIcon: React.FC<StatusIconProps> = ({
  icon,
  count = 0,
  variant = "neutral",
  className = "",
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative ${
        onClick ? "cursor-pointer hover:opacity-90" : ""
      } ${className}`}
    >
      {icon}
      {count > 0 && <NotificationBadge count={count} variant={variant} />}
    </button>
  );
};
